import { colors } from '@alixpartners/ui-components';
import {
	formatSpendWithDecimalAndSymbol,
	getFormattedSpendWithSymbol,
} from './number';

import { isArray } from 'lodash';

export const filterNames = {
	scatterPlotState: 'scatterPlotState',
	scatterPlotWorkerType: 'scatterPlotWorkerType',
	// scatterPlotEmpTotalMin: 'scatterPlotEmpTotalMin',
	// scatterPlotEmpTotalMax: 'scatterPlotEmpTotalMax',
	scatterPlotBLSYear: 'scatterPlotBLSYear',
	scatterPlotCagr: 'scatterPlotCagr',
	scatterPlotEmpTotalRange: 'scatterPlotEmpTotalRange',
	stackedBarChartJobClass: 'stackedBarChartJobClass',
	// stackedBarChartGrossAmountMin: 'stackedBarChartGrossAmountMin',
	// stackedBarChartGrossAmountMax: 'stackedBarChartGrossAmountMax',
	stackedBarChartGrossAmountRange: 'stackedBarChartGrossAmountRange',
	boxWhiskerClientJobClass: 'boxWhiskerClientJobClass',
	boxWhiskerClientSumSpendOverJobTitleMin:
		'boxWhiskerClientSumSpendOverJobTitleMin',
	boxWhiskerClientSumSpendOverJobTitleMax:
		'boxWhiskerClientSumSpendOverJobTitleMax',
	boxWhiskerClientSumSpendOverJobTitleRange:
		'boxWhiskerClientSumSpendOverJobTitleRange',
	boxWhiskerBLSWorkerType: 'boxWhiskerBLSWorkerType',
	boxWhiskerBLSYear: 'boxWhiskerBLSYear',
	mapStateWorkerType: 'mapStateWorkerType',
	mapStateBLSYear: 'mapStateBLSYear',
	mapCityWorkerType: 'mapCityWorkerType',
	mapCityBLSYear: 'mapCityBLSYear',
};
export default filterNames;

export const generateToolTip = dataObj => {
	// eslint-disable-next-line array-callback-return
	const result = Object.keys(dataObj).map(key => {
		if (!isArray(dataObj[key])) {
			return {
				name: KeyMapper[key] || key,
				value: dataObj[key],
			};
		}
	});
	return result;
};
export const generateBLSData = blsData => {
	const newData = [];
	blsData.forEach(data => {
		const state = data.state;
		const foundIndex = newData.findIndex(obj => obj.state === state);
		if (foundIndex !== -1) {
			newData[foundIndex] = {
				...newData[foundIndex],
				value: (newData[foundIndex].value + data.avG_H_MEDIAN) / 2,
				avG_H_MEDIAN:
					(newData[foundIndex].avG_H_MEDIAN + data.avG_H_MEDIAN) / 2,
				suM_TOT_EMP: (newData[foundIndex].suM_TOT_EMP + data.suM_TOT_EMP) / 2,
				avG_H_PCT10: (newData[foundIndex].avG_H_PCT10 + data.avG_H_PCT10) / 2,
				avG_H_PCT25: (newData[foundIndex].avG_H_PCT25 + data.avG_H_PCT25) / 2,
				avG_H_MEAN: (newData[foundIndex].avG_H_MEAN + data.avG_H_MEAN) / 2,
				avG_H_PCT75: (newData[foundIndex].avG_H_PCT75 + data.avG_H_PCT75) / 2,
				avG_H_PCT90: (newData[foundIndex].avG_H_PCT90 + data.avG_H_PCT90) / 2,
				count: newData[foundIndex].count + 1,
			};
			newData[foundIndex].tooltip = generateToolTip(newData[foundIndex])
				.filter(data => data && data.name)
				.filter(data => data.name !== 'drilldown')
				.filter(data => data.name !== 'value')
				.filter(data => data.name !== 'City')
				.filter(data => data.name !== 'County FIPS')
				.filter(data => data.name !== 'Latitude')
				.filter(data => data.name !== 'Longitude');
		} else {
			newData.push({
				state: data.state,
				stateCode:
					data.countY_FIPS.toString().length === 5
						? 'US' + data.countY_FIPS.toString().substring(0, 2)
						: 'US' + ('0' + data.countY_FIPS.toString()).substring(0, 2),
				value: data.avG_H_MEDIAN,
				avG_H_MEDIAN: data.avG_H_MEDIAN,
				suM_TOT_EMP: data.suM_TOT_EMP,
				avG_H_PCT10: data.avG_H_PCT10,
				avG_H_PCT25: data.avG_H_PCT25,
				avG_H_MEAN: data.avG_H_MEAN,
				avG_H_PCT75: data.avG_H_PCT75,
				avG_H_PCT90: data.avG_H_PCT90,
				drilldown: true,
				count: 1,
				tooltip: generateToolTip(data)
					.filter(data => data && data.name)
					.filter(data => data.name !== 'drilldown')
					.filter(data => data.name !== 'value')
					.filter(data => data.name !== 'City')
					.filter(data => data.name !== 'County FIPS')
					.filter(data => data.name !== 'Latitude')
					.filter(data => data.name !== 'Longitude'),
			});
		}
	});
	return newData;
};

export const getMarkUpChartData = data => {
	const supplierNames = new Set();
	const markUpCategories = new Set();

	data.forEach(d => {
		supplierNames.add(d.supplier);
		markUpCategories.add(Math.floor(d.markUp_Category * 100));
	});
	const markupdata = [];
	supplierNames.forEach(supplier => {
		const newObj = {
			name: supplier,
			data: [],
			total: 0,
		};
		data.forEach(d => {
			if (d.supplier === supplier) {
				if (newObj.data.find(o => o.name === d.jobTitle)) {
					let foundObj = newObj.data.find(o => o.name === d.jobTitle);
					const markupArray = Array.from(markUpCategories).sort();
					const index = markupArray.findIndex(
						o => o === Math.floor(d.markUp_Category * 100)
					);
					foundObj.data[index] = d.grossAmount;
					foundObj.tooltip = generateToolTip(foundObj);
					foundObj.total = foundObj.total + d.grossAmount;
					newObj.total = newObj.total + d.grossAmount;
				} else {
					const markupArray = Array.from(markUpCategories).sort();
					const newdata = new Array(markupArray.length).fill(0);
					const index = markupArray.findIndex(
						o => o === Math.floor(d.markUp_Category * 100)
					);
					newdata[index] = d.grossAmount;
					let newObj1 = {
						name: d.jobTitle,
						data: newdata,
						markUp_Category: markupArray,
						supplier: d.supplier,
						total: d.grossAmount,
					};
					newObj1 = { ...newObj1, tooltip: generateToolTip(newObj1) };
					newObj.data.push(newObj1);
					newObj.total = newObj.total + d.grossAmount;
				}
			}
		});

		markupdata.push(newObj);
	});
	return { markupdata, markupCategoriesArray: Array.from(markUpCategories) };
};

export const FONTSTYLE = {
	fontSize: '11px',
	fontWeight: '400',
	lineHeight: '13px',
	letterSpacing: 0,
	color: colors.grey7,
};

export const getSpendBreakdownFormattedData = inputObject => {
	const outputArray = Object.keys(inputObject[0])
		.filter(key => !key.endsWith('_Percentage') && key !== 'sum_all')
		// eslint-disable-next-line array-callback-return
		.map(key => {
			const keyName = KeyMapper[key];
			if (key !== 'sum_all') {
				return {
					name: keyName,
					y: inputObject[0][key],
					tooltip: [
						{
							name: keyName,
							value: formatSpendWithDecimalAndSymbol(
								inputObject[0][key],
								'$',
								false,
								1
							),
						},
					],
				};
			}
		})
		.reverse();

	return outputArray;
};

export const spendFormatter = (value, withZero) => {
	const currencySymbol = '$';
	return value || withZero
		? getFormattedSpendWithSymbol(value, currencySymbol, true).toUpperCase()
		: '-';
};
export const stateColorMap = {
	AL: '#FF5733',
	AK: '#33FF57',
	AZ: '#5733FF',
	AR: '#FF33A1',
	CA: '#33FFC5',
	CO: '#FFB233',
	CT: '#3373FF',
	DE: '#FF336D',
	FL: '#33FF8C',
	GA: '#D633FF',
	HI: '#FF5733',
	ID: '#33FF57',
	IL: '#5733FF',
	IN: '#FF33A1',
	IA: '#33FFC5',
	KS: '#FFB233',
	KY: '#3373FF',
	LA: '#FF336D',
	ME: '#33FF8C',
	MD: '#D633FF',
	MA: '#FF5733',
	MI: '#33FF57',
	MN: '#5733FF',
	MS: '#FF33A1',
	MO: '#33FFC5',
	MT: '#FFB233',
	NE: '#3373FF',
	NV: '#FF336D',
	NH: '#33FF8C',
	NJ: '#D633FF',
	NM: '#FF5733',
	NY: '#33FF57',
	NC: '#5733FF',
	ND: '#FF33A1',
	OH: '#33FFC5',
	OK: '#FFB233',
	OR: '#3373FF',
	PA: '#FF336D',
	RI: '#33FF8C',
	SC: '#D633FF',
	SD: '#FF5733',
	TN: '#33FF57',
	TX: '#5733FF',
	UT: '#FF33A1',
	VT: '#33FFC5',
	VA: '#FFB233',
	WA: '#3373FF',
	WV: '#FF336D',
	WI: '#33FF8C',
	WY: '#D633FF',
};
export const KeyMapper = {
	h_MEDIAN: 'Hourly MEDIAN',
	cagr: 'CAGR',
	areA_TITLE: 'Area Title',
	jobTitle: 'Job Title',
	billRate: 'Bill Rate',
	rateCardMax: 'Rate Card Max',
	sumHours: 'Sum Hours',
	name: 'Job Title',
	low: 'Lower Whisker',
	q1: 'Lower Hinge',
	median: 'Median',
	q3: 'Upper Hinge',
	high: 'Upper Whisker',
	city: 'City',
	lat: 'Latitude',
	lng: 'Longitude',
	state: 'State',
	avG_H_MEDIAN: 'Avg H_Median',
	suM_TOT_EMP: 'Sum Total Employee',
	avG_H_PCT10: 'Avg H_PCT10',
	avG_H_PCT25: 'Avg H_PCT25',
	avG_H_MEAN: 'Avg H_Mean',
	avG_H_PCT75: 'Avg H_PCT75',
	avG_H_PCT90: 'Avg H_PCT90',
	countY_FIPS: 'County FIPS',
	beeline_Fee: 'Beeline Fee',
	msP_Fee: 'MSP Fee',
	tax_Amount: 'Tax Amount',
	other_Fee: 'Other Fee',
	net_Supplier_Payable: 'Net Supplier Payable',
};
